import React, { useState, useEffect } from 'react';
import { CheckOutlined } from '@mui/icons-material';
import Button from '../../atoms/Button/Button';
import ConfirmBar from '../../atoms/ConfirmBar/ConfirmBar';
import './ProfileEditForm.css';

const Field = ({ label, name, value, onChange, type = 'text' }) => (
  <div className="pef-field">
    <label className="pef-label">{label}</label>
    <input
      className="pef-input"
      type={type}
      name={name}
      value={value || ''}
      onChange={onChange}
      placeholder={label}
    />
  </div>
);

const ProfileEditForm = ({ formData, onChange, onSave, saving, initialData }) => {
  const [isDirty,     setIsDirty]     = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (!initialData) return;
    const changed = Object.keys(formData).some(
      (k) => (formData[k] || '') !== (initialData[k] || '')
    );
    setIsDirty(changed);
  }, [formData, initialData]);

  const handleConfirm = () => { setShowConfirm(false); onSave(); };

  return (
    <div className="pef-wrapper">
      <div className="pef-grid">
        <Field label="Prénom"       name="name"         value={formData.name}         onChange={onChange} />
        <Field label="Nom"          name="lastname"     value={formData.lastname}     onChange={onChange} />
        <Field label="Organisation" name="organization" value={formData.organization} onChange={onChange} />
        <Field label="Adresse"      name="adress"       value={formData.adress}       onChange={onChange} />
        <Field label="Ville"        name="city"         value={formData.city}         onChange={onChange} />
        <Field label="Pays"         name="country"      value={formData.country}      onChange={onChange} />
      </div>

      <div className="pef-actions">
        <Button
          variant="primary"
          label={saving ? 'Enregistrement…' : 'Enregistrer les modifications'}
          icon={!saving ? <CheckOutlined /> : null}
          onClick={() => setShowConfirm(true)}
          disabled={saving || !isDirty}
        />
      </div>

      {showConfirm && (
        <ConfirmBar
          message="Enregistrer les modifications du profil"
          onConfirm={handleConfirm}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
};

export default ProfileEditForm;